export default __webpack_public_path__ + "static/media/product_2.3.3914f9eb.jpg";